/* Pagina de produto: markup, CSS e JS portados da referencia.
   Variantes, galeria, especificacoes e avaliacoes vem do Liquid via #mpdp-data. */
(function(){
var _el = document.getElementById('mpdp-data');
var D = _el ? JSON.parse(_el.textContent) : null;
if (!D) { console.warn('mpdp: sem dados'); return; }
window.MPDP = D;
if (!Array.isArray(D.reviews)) D.reviews = [];
if (!Array.isArray(D.pinnedReviews)) D.pinnedReviews = [];
/* linha sem cor: a matriz e chaveada por string vazia */
if (D.activeColor == null) D.activeColor = '';

/* O Liquid entrega uma LISTA (D.items) dos produtos da pagina. Aqui ela vira uma matriz
   POR BRANDING: cada opcao de branding tem suas proprias tallas, cores e guia de tamanhos.
   D.variants/sizeOrder/colors apontam sempre para o branding ATIVO, que e o que o motor
   portado da referencia consome sem saber que existe um eixo a mais. */
(function(){
  function vazio(){ return { variants:{}, sizeOrder:[], colors:[], colorLabels:{}, sizeGuide:[] }; }
  D.byBranding = {};
  D.brandings = [];
  if (!D.items || !D.items.length) {
    var v = vazio();
    D.variants=v.variants; D.sizeOrder=v.sizeOrder; D.colors=v.colors;
    D.colorLabels=v.colorLabels; D.sizeGuide=v.sizeGuide;
    return;
  }
  var kg2lb = 2.20462;
  var num = function(s){ var m = String(s || '').match(/[0-9.,]+/); return m ? parseFloat(m[0].replace(',', '.')) : null; };
  var ordemB = {};

  D.items.forEach(function(it){
    var b = it.branding || '';
    if (!D.byBranding[b]) { D.byBranding[b] = { V:{}, ordT:[], cores:[], labels:{}, vistoC:{} }; }
    ordemB[b] = it.brandingOrden || 0;
    var g = D.byBranding[b];
    if (!g.V[it.talla]) { g.V[it.talla] = {}; g.ordT.push({ n: it.talla, o: it.orden }); }
    g.V[it.talla][it.colorKey || ''] = {
      id: it.id, sku: it.sku, price: it.price, compare: it.compare || null,
      checkout: it.checkout, dims_cm: it.dims_cm, dims_in: it.dims_in,
      weight: it.weight, volume: it.volume, status: it.status,
      images: it.images, url: it.url, outfits: it.outfits, locks: it.locks,
      /* o adaptador copia campo a campo: campo novo que nao entrar aqui chega
         undefined no motor, sem erro nenhum. */
      talla: it.talla
    };
    if (it.colorKey && !g.vistoC[it.colorKey]) {
      g.vistoC[it.colorKey] = 1;
      g.cores.push({ name: it.colorKey, color: it.hex, o: it.colorOrden });
      g.labels[it.colorKey] = it.color;
    }
  });

  var porO = function(a, b){ return (a.o || 0) - (b.o || 0); };
  Object.keys(D.byBranding).forEach(function(b){
    var g = D.byBranding[b];
    g.ordT.sort(porO); g.cores.sort(porO);
    var sizeOrder = g.ordT.map(function(x){ return x.n; });
    D.byBranding[b] = {
      variants: g.V, sizeOrder: sizeOrder, colors: g.cores, colorLabels: g.labels,
      sizeGuide: sizeOrder.map(function(t){
        var k = Object.keys(g.V[t])[0], v = g.V[t][k];
        var kg = num(v.weight);
        return { name: t, img: (v.images && v.images[0]) || '', locks: v.locks,
          cm: v.dims_cm || '', 'in': v.dims_in || '',
          kg: v.weight || '', lbs: kg ? (kg*kg2lb).toFixed(1) + ' lbs' : (v.weight || ''),
          l: v.volume || '', gal: v.volume || '',
          outfits: v.outfits || '', days: '' };
      })
    };
  });

  D.brandings = Object.keys(D.byBranding).sort(function(a,b){ return (ordemB[a]||0) - (ordemB[b]||0); });
  if (!D.activeBranding || !D.byBranding[D.activeBranding]) D.activeBranding = D.brandings[0];
  var at = D.byBranding[D.activeBranding] || vazio();
  D.variants = at.variants; D.sizeOrder = at.sizeOrder; D.colors = at.colors;
  D.colorLabels = at.colorLabels; D.sizeGuide = at.sizeGuide;
})();


/* ---------- */


            (function(){
              var idx=0, total=3, track, dots, autoTimer;
              function go(i){
                idx=((i%total)+total)%total;
                track.style.transform='translateX(-'+idx*100+'%)';
                dots.forEach(function(d,j){
                  d.classList.remove('active');
                  void d.offsetWidth;
                  if(j===idx) d.classList.add('active');
                });
              }
              function resetAuto(){clearInterval(autoTimer);autoTimer=setInterval(function(){go(idx+1);},4500);}
              window.stepsGo=function(d){go(idx+d);resetAuto();};
              window.stepsTo=function(i){go(i);resetAuto();};
              document.addEventListener('DOMContentLoaded', function(){
                track=document.getElementById('steps-track');
                dots=document.querySelectorAll('#steps-dots .steps-dot');
                if(!track) return;
                resetAuto();
                var sx=0;
                track.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
                track.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){go(idx+(dx<0?1:-1));resetAuto();}},{passive:true});
              });
            })();
            

/* ---------- */


    document.querySelectorAll('.mpdp .faq__q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq__item');
        var isOpen = item.classList.contains('faq__item--open');
        document.querySelectorAll('.mpdp .faq__item').forEach(function(i) {
          i.classList.remove('faq__item--open');
          i.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('faq__item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  

/* ---------- */



    // Smooth scroll to top
    function goToShop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

  

/* ---------- */



    /* ---- SHOP: Full Variant Matrix (Size Ã— Color) ---- */

    /* â”€â”€ Variant data â”€â”€ */
    /* imagens e dados vem do Liquid (#mpdp-data). */
    
    var VARIANTS = D.variants;

    /* Size display order */
    var SIZE_ORDER = D.sizeOrder;

    /* All possible colors — Classic metallic finishes (CSS swatch, no finish grouping) */
    /* As chaves (name) ficam em inglês porque são usadas internamente nas VARIANTS;
       o rótulo exibido ao usuário vem de COLOR_LABELS (espanhol). */
    var ALL_COLORS = D.colors;

    /* Rótulos de cor exibidos ao usuário (ES) */
    var COLOR_LABELS = D.colorLabels;
    function colorLabel(n) { return COLOR_LABELS[n] || n; }

    /* Static specs shared by all variants (RIMOWA Classic — anodized aluminum + leather) */
    var SPECS_SHARED = D.specs;

    var STATUS_LABELS = { 'in_stock': 'In stock', 'limited': 'Low stock', 'out_of_stock': 'Sold out' };
    var STATUS_COLORS = { 'in_stock': '#2a7a2a', 'limited': '#b8860b', 'out_of_stock': '#c0392b' };

    let currentImages = [];
    let currentGalleryIdx = 0;
    let activeSize = D.activeSize;
    let activeColor = D.activeColor;

    function preloadImages(images) {
      var run = function(){ images.forEach(function(src) { if(src) { var i = new Image(); i.src = src; } }); };
      /* fora do caminho critico: nao disputa banda com a primeira pintura.
         Mantido para a troca de cor/tamanho continuar instantanea. */
      if (typeof requestIdleCallback === 'function') requestIdleCallback(run, {timeout: 2500});
      else setTimeout(run, 1200);
    }

    /* Get the current variant object, or null */
    function getVariant(size, color) {
      var s = VARIANTS[size];
      return s ? (s[color] || null) : null;
    }

    /* Get available colors for a given size */
    function getColorsForSize(size) {
      var s = VARIANTS[size];
      if (!s) return [];
      return ALL_COLORS.filter(function(c) { return !!s[c.name]; });
    }

    /* â”€â”€ Build color swatches (grouped by finish, filtered by size) â”€â”€ */
    function buildColorSwatches() {
      var container = document.getElementById('color-swatches');
      container.innerHTML = '';
      var colors = getColorsForSize(activeSize);
      /* group by finish, preserving order; '' = no finish sub-label (ex.: Classic metallics) */
      var finishes = [];
      colors.forEach(function(c) { var f = c.finish || ''; if (finishes.indexOf(f) === -1) finishes.push(f); });
      finishes.forEach(function(fin) {
        var group = colors.filter(function(c) { return (c.finish || '') === fin; });
        if (!group.length) return;
        var row = document.createElement('div');
        row.className = 'color-row';
        if (fin) {
          var lbl = document.createElement('span');
          lbl.className = 'color-row__label';
          lbl.textContent = fin.toUpperCase();
          row.appendChild(lbl);
        }
        var chips = document.createElement('div');
        chips.className = 'color-chips';
        group.forEach(function(c) {
          var v = getVariant(activeSize, c.name);
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'color-chip' + (c.name === activeColor ? ' selected' : '');
          if (v && v.status === 'out_of_stock') chip.style.opacity = '0.4';
          chip.title = colorLabel(c.name);
          chip.dataset.color = c.name;
          chip.setAttribute('aria-label', colorLabel(c.name));
          chip.onclick = function() { selectColor(c.name); };
          var fill;
          if (c.swatch) {
            fill = document.createElement('img');
            fill.className = 'color-chip__fill';
            fill.src = c.swatch;
            fill.alt = c.name;
            fill.loading = 'lazy';
            fill.style.background = c.color || '#ccc';
          } else {
            fill = document.createElement('span');
            fill.className = 'color-chip__fill';
            fill.style.background = c.color || '#ccc';
          }
          chip.appendChild(fill);
          chips.appendChild(chip);
        });
        row.appendChild(chips);
        container.appendChild(row);
      });
    }

    function selectColor(colorName) {
      activeColor = colorName;
      document.getElementById('selected-color-name').textContent = colorLabel(colorName);
      document.querySelectorAll('.color-chip').forEach(function(s) {
        s.classList.toggle('selected', s.dataset.color === colorName);
      });
      applyVariant();
    }

    /* â”€â”€ Build size dropdown options â”€â”€ */
    function buildSizeBlocks() {
      var list = document.getElementById('size-dropdown-list');
      if (!list) return;
      list.innerHTML = '';
      SIZE_ORDER.forEach(function(sizeName) {
        if (!VARIANTS[sizeName]) return;
        var dimsVariant = getVariant(sizeName, activeColor) || getVariant(sizeName, Object.keys(VARIANTS[sizeName]||{})[0]);
        var li = document.createElement('li');
        li.className = 'size-dropdown__option' + (sizeName === activeSize ? ' selected' : '');
        li.setAttribute('role', 'option');
        li.dataset.size = sizeName;
        li.onclick = function() { selectSize(sizeName); closeSizeDropdown(); };
        li.innerHTML = '<span class="o-name">' + sizeName + '</span><span class="o-dims">' + (dimsVariant ? dimsVariant.dims_in : '') + '</span>';
        list.appendChild(li);
      });
    }

    function toggleSizeDropdown() {
      var dd = document.getElementById('size-dropdown');
      if (!dd) return;
      var open = dd.classList.toggle('open');
      var t = dd.querySelector('.size-dropdown__trigger');
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeSizeDropdown() {
      var dd = document.getElementById('size-dropdown');
      if (!dd) return;
      dd.classList.remove('open');
      var t = dd.querySelector('.size-dropdown__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('click', function(e) {
      var dd = document.getElementById('size-dropdown');
      if (dd && !dd.contains(e.target)) closeSizeDropdown();
    });

    function selectSize(sizeName) {
      activeSize = sizeName;
      var titleEl = document.getElementById('shop-title');
      if (titleEl) titleEl.textContent = sizeName;
      var bcEl = document.getElementById('breadcrumb-size');
      if (bcEl) bcEl.textContent = sizeName;
      document.getElementById('selected-size-name').textContent = sizeName;
      var dimsVariant = getVariant(sizeName, activeColor) || getVariant(sizeName, Object.keys(VARIANTS[sizeName]||{})[0]);
      document.getElementById('selected-size-dims').textContent = dimsVariant ? dimsVariant.dims_in : '';
      document.querySelectorAll('.size-dropdown__option').forEach(function(o) {
        o.classList.toggle('selected', o.dataset.size === sizeName);
      });

      /* If current color not available for new size, pick first available */
      var colors = getColorsForSize(sizeName);
      var hasColor = colors.some(function(c) { return c.name === activeColor; });
      if (!hasColor && colors.length > 0) {
        activeColor = colors[0].name;
        document.getElementById('selected-color-name').textContent = colorLabel(activeColor);
      }
      buildColorSwatches();
      applyVariant();
    }

    /* â”€â”€ Apply variant: update price, gallery, stock, specs â”€â”€ */
    /* Bundles phantom: os codigos ja existem na loja; a faixa e escolhida pela quantidade */
    var BUNDLE_TIERS = D.bundleTiers;

    function bundleFor(qty) {
      for (var i = 0; i < BUNDLE_TIERS.length; i++) {
        if (qty >= BUNDLE_TIERS[i].qty) return BUNDLE_TIERS[i];
      }
      return null;
    }

    function nextBundleAfter(qty) {
      for (var i = BUNDLE_TIERS.length - 1; i >= 0; i--) {
        if (BUNDLE_TIERS[i].qty > qty) return BUNDLE_TIERS[i];
      }
      return null;
    }

    function updateBundleHint() {
      var el = document.getElementById('bundle-hint');
      if (!el) return;
      var sel = document.querySelector('.mpdp .quantity-selector');
      var qty = parseInt(sel && sel.value) || 1;
      var v = getVariant(activeSize, activeColor);
      var unit = v ? parseFloat(v.price) : 0;
      var tier = bundleFor(qty);
      var next = nextBundleAfter(qty);
      var html;
      if (tier) {
        html = '<span><strong>\u2212' + tier.off + '%</strong> applied at checkout \u2014 you save <strong>'
             + fmtPrice(unit * qty * tier.off / 100) + '</strong></span>';
        if (next) html += '<span>\u00b7 with ' + next.qty + ' units, <strong>\u2212' + next.off + '%</strong></span>';
      } else if (BUNDLE_TIERS && BUNDLE_TIERS.length) {
        /* texto derivado dos tiers reais: escrito na mao ele continuava prometendo
           \u221232% com 5 unidades muito depois de a oferta ter mudado */
        var menor = BUNDLE_TIERS[BUNDLE_TIERS.length - 1], maior = BUNDLE_TIERS[0];
        html = '<span>Take <strong>' + menor.qty + ' units</strong> and save <strong>' + menor.off + '%</strong>';
        if (maior.qty !== menor.qty) html += ' \u2014 up to <strong>\u2212' + maior.off + '%</strong> with ' + maior.qty;
        html += '</span>';
      } else {
        html = '';   /* sem oferta configurada nesta linha: nao prometer nada */
      }
      el.innerHTML = html;
    }

    function applyVariant() {
      var v = getVariant(activeSize, activeColor);
      if (!v) return;

      /* Price */
      updatePriceDisplay(v.price, v.compare);

      /* Gallery */
      if (v.images && v.images.length > 0) {
        updateGalleryFromImages(v.images);
        preloadImages(v.images);
        updateDecorativeMedia(v.images);
      }

      /* Stock indicator */
      var stockEl = document.getElementById('stock-indicator');
      if (stockEl) {
        stockEl.textContent = STATUS_LABELS[v.status] || 'In stock';
        stockEl.style.color = STATUS_COLORS[v.status] || '#2a7a2a';
      }

      /* Buy button */
      var buyBtn = document.querySelector('.shop-add-btn');
      if (buyBtn) {
        if (v.status === 'out_of_stock') {
          buyBtn.disabled = true;
          buyBtn.removeAttribute('href');
          buyBtn.querySelector('svg').nextSibling.textContent = ' Sold out';
        } else {
          buyBtn.disabled = false;
          var btnText = buyBtn.querySelector('svg');
          if (btnText && btnText.nextSibling) btnText.nextSibling.textContent = ' Buy now';
        }
      }

      /* Use case volume */
      var ucVol = document.getElementById('usecase-volume');
      if (ucVol && v.volume) ucVol.textContent = v.volume;

      /* Specs accordion */
      updateSpecsForVariant(v);

      /* Bundle phantom */
      updateBundleHint();

      atualizarTextosDaFicha();
    }

    function fmtPrice(p) {
      if (typeof p === 'string' && /[^0-9.,\s]/.test(p)) return p;
      var n = parseFloat(p);
      if (isNaN(n)) return String(p);
      var s = n.toLocaleString(D.locale || 'es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      /* D.money vem de shop.money_format e traz o marcador amount entre chaves duplas */
      return String(D.money || '').indexOf('amount') >= 0
        ? String(D.money).replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, s)
        : s;
    }

    function updatePriceDisplay(price, comparePrice) {
      var el = document.getElementById('product-price-sale');
      if (!el) return;
      el.classList.remove('price-pop');
      void el.offsetWidth;
      el.textContent = fmtPrice(price);
      el.classList.add('price-pop');

      var compareEl = document.getElementById('product-price-compare');
      if (compareEl && comparePrice) {
        compareEl.textContent = fmtPrice(comparePrice);
      }
    }

    function updateSpecsForVariant(v) {
      var detEl = document.getElementById('acc-details-content');
      if (!detEl) return;
      var specs = [];
      if (v.sku) specs.push(['SKU', v.sku]);
      specs.push(['Size', activeSize]);
      specs.push(['Color', colorLabel(activeColor)]);
      specs.push(['Dimensions (cm)', v.dims_cm]);
      specs.push(['Dimensions (in)', v.dims_in]);
      if (v.weight && v.weight !== 'N/A') specs.push(['Weight', v.weight]);
      if (v.volume && v.volume !== 'N/A') specs.push(['Volume', v.volume]);
      if (v.locks) specs.push(['Locks (number)', String(v.locks)]);
      specs = specs.concat(SPECS_SHARED);
      detEl.innerHTML = '<ul>' + specs.map(function(r) {
        return '<li><strong>' + r[0] + ':</strong> ' + r[1] + '</li>';
      }).join('') + '</ul>';
    }

    /* Cross-fade the main gallery image to a new src */
    var _fadeTimer = null;
    var _galleryWant = null;
    function fadeGalleryTo(src) {
      var mainImg = document.getElementById('gallery-main-img');
      if (!mainImg || !src) return;
      _galleryWant = src; /* a última intenção vence a corrida */
      if (mainImg.getAttribute('src') === src) { mainImg.style.opacity = '1'; return; }
      if (_fadeTimer) { clearTimeout(_fadeTimer); _fadeTimer = null; }
      mainImg.style.opacity = '0';
      _fadeTimer = setTimeout(function() {
        _fadeTimer = null;
        var want = src;
        var apply = function() {
          if (_galleryWant !== want) return; /* já pediram outra imagem -> ignora */
          mainImg.src = src;
          requestAnimationFrame(function() { mainImg.style.opacity = '1'; });
        };
        var probe = new Image();
        probe.onload = apply;
        probe.onerror = apply;
        probe.src = src;
      }, 180);
    }

    
    /* ---- perf: miniatura de review no tamanho em que aparece (72px) ----
       Medido: as fotos de cliente pesam 700 KB-1,4 MB e sao exibidas a 72x72.
       ?width=200 cobre telas 2x e derruba ~98% dos bytes. O lightbox segue
       abrindo o arquivo original, entao a qualidade ao ampliar nao muda.
       As imagens de PRODUTO nao passam por aqui de proposito: o AVIF original
       ja e menor que qualquer reencode do CDN. */
    function _w(src, w) {
      if (!src || typeof src !== 'string') return src;
      if (src.indexOf('?') > -1) return src;
      return src + '?width=' + w;
    }

    function updateGalleryFromImages(images) {
      currentImages = images;
      currentGalleryIdx = 0;
      fadeGalleryTo(images[0]);
      var strip = document.querySelector('.thumbnail-strip');
      if (!strip) return;
      strip.innerHTML = '';
      images.forEach(function(src, i) {
        var div = document.createElement('div');
        div.className = 'thumbnail thumbnail-anim' + (i === 0 ? ' active' : '');
        div.style.animationDelay = (i * 30) + 'ms';
        div.onclick = (function(idx, el) { return function() { selectThumb(el, idx); }; })(i, div);
        var img = document.createElement('img');
        img.src = src;
        img.alt = 'Vista ' + (i + 1);
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
        div.appendChild(img);
        strip.appendChild(div);
      });
    }

    /* Update decorative section images (carousel / use-cases / features) per variant */
    function updateDecorativeMedia(images) {
      if (!images || !images.length) return;
      var pick = function(i) { return images[i % images.length]; };
      var setSrc = function(nodes, map) {
        nodes.forEach(function(img, i) {
          var idx = (map && map[i] != null) ? map[i] : i;
          var src = pick(idx);
          if (img.getAttribute('src') !== src) img.src = src;
        });
      };
      setSrc(document.querySelectorAll('#steps-track .step-slide__img img'), [0, 1, 2]);
      setSrc(document.querySelectorAll('#use-cases .usecase-card__img img'), [3, 4, 0, 1, 2, 3]);
      setSrc(document.querySelectorAll('#features .feature-card__img img'), [0, 1, 2, 3]);
    }

    function initVariants() {
      buildSizeBlocks();
      buildColorSwatches();
      montarBranding();
      selectBranding(activeBranding);
    }

    /* ---- Gallery thumbnails ---- */
    function selectThumb(el, idx) {
      document.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
      el.classList.add('active');
      currentGalleryIdx = idx;
      fadeGalleryTo(currentImages[idx] || currentImages[0] || '');
    }

    function galleryNext() {
      const thumbs = document.querySelectorAll('.thumbnail');
      currentGalleryIdx = (currentGalleryIdx + 1) % thumbs.length;
      thumbs.forEach((t, i) => t.classList.toggle('active', i === currentGalleryIdx));
      fadeGalleryTo(currentImages[currentGalleryIdx] || currentImages[0] || '');
    }

    function galleryPrev() {
      const thumbs = document.querySelectorAll('.thumbnail');
      currentGalleryIdx = (currentGalleryIdx - 1 + thumbs.length) % thumbs.length;
      thumbs.forEach((t, i) => t.classList.toggle('active', i === currentGalleryIdx));
      fadeGalleryTo(currentImages[currentGalleryIdx] || currentImages[0] || '');
    }

    document.addEventListener('DOMContentLoaded', initVariants);

    /* ---- Reviews data ---- */
  var REVIEWS_DATA = D.reviews;
  (function(){
    /* ids fixados no topo, nesta ordem, independente da data.
       o resto da lista segue por data decrescente. */
    var PINNED_IDS = D.pinnedReviews;

    var _sorted = (function(){
      var byDate = function(a,b){ return new Date(b.date) - new Date(a.date); };
      var pinned = [];
      PINNED_IDS.forEach(function(id){
        for (var k = 0; k < REVIEWS_DATA.length; k++) {
          if (REVIEWS_DATA[k].id === id) { pinned.push(REVIEWS_DATA[k]); break; }
        }
      });
      var rest = REVIEWS_DATA.filter(function(r){
        return PINNED_IDS.indexOf(r.id) === -1;
      }).sort(byDate);
      return pinned.concat(rest);
    })();
    var _rendered = 0, BATCH = 6;

    function _esc(s) {
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
    function _stars(n) {
      var s = ''; for (var i=0;i<5;i++) s += i<n?'\u2605':'\u2606'; return s;
    }
    function _date(iso) {
      var d = new Date(iso);
      var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return mo[d.getMonth()]+' '+d.getDate()+', '+d.getFullYear();
    }

    function renderBatch() {
      var list = document.getElementById('reviews-list');
      if (!list) return;
      var end = Math.min(_rendered + BATCH, _sorted.length);
      var frag = document.createDocumentFragment();
      for (var i = _rendered; i < end; i++) {
        var r = _sorted[i];
        var div = document.createElement('div');
        div.className = 'review-item review-item-anim';
        div.style.animationDelay = ((i - _rendered) * 45) + 'ms';
        var photosHtml = '';
        if (r.photos.length > 0) {
          photosHtml = '<div class="review-item__photos">';
          r.photos.forEach(function(url){
            photosHtml += '<img class="review-photo-thumb" src="'+_w(url,200)+'" alt="Foto" loading="lazy" onclick="openReviewLightbox(\''+url+'\')">';
          });
          photosHtml += '</div>';
        }
        var verifiedHtml = r.verified ? '<span class="review-verified">\u2713 Verificada</span>' : '';
        var initial = r.author.charAt(0).toUpperCase();
        div.innerHTML =
          '<div class="review-avatar">'+initial+'</div>'+
          '<div class="review-item__content">'+
            '<div class="review-item__header">'+
              '<span class="review-item__meta">'+_esc(r.author)+' · '+_date(r.date)+verifiedHtml+'</span>'+
            '</div>'+
            '<div style="display:flex;align-items:center;gap:12px;margin-bottom:4px;">'+
              '<span class="review-item__stars">'+_stars(r.score)+'</span>'+
              '<span class="review-item__title">'+_esc(r.title)+'</span>'+
            '</div>'+
            '<p class="review-item__body">'+_esc(r.content).replace(/\n/g,'<br>')+'</p>'+
            photosHtml+
          '</div>';
        frag.appendChild(div);
      }
      list.appendChild(frag);
      _rendered = end;
      var btn = document.getElementById('reviews-load-more-btn');
      btn.textContent = 'See all reviews (' + _sorted.length + ')';
    }

    document.addEventListener('DOMContentLoaded', function(){
      renderBatch();
      if (!document.getElementById('reviews-load-more-btn')) return;
      document.getElementById('reviews-load-more-btn').onclick = function(){ window.openReviewsPopup(); };
    });

    /* â”€â”€ Reviews popup carousel â”€â”€ */
    var _popupIdx = 0;
    var _popupBuilt = false;

    function _buildPopupCards() {
      if (_popupBuilt) return;
      var body = document.getElementById('reviews-popup-body');
      if (!body) return;
      _sorted.forEach(function(r, i) {
        var card = document.createElement('div');
        card.className = 'reviews-popup__card' + (i === 0 ? ' active' : '');
        card.setAttribute('data-idx', i);
        var photosHtml = '';
        if (r.photos && r.photos.length > 0) {
          photosHtml = '<div class="reviews-popup__card-photos">';
          r.photos.forEach(function(url) {
            photosHtml += '<img src="'+_w(url,200)+'" alt="Foto" loading="lazy" onclick="openReviewLightbox(\''+url+'\')">';
          });
          photosHtml += '</div>';
        }
        var verifiedHtml = r.verified ? ' · <span style="color:#2a7d2a">\u2713 Verificada</span>' : '';
        var popupInitial = r.author.charAt(0).toUpperCase();
        card.innerHTML =
          '<div style="display:flex;align-items:center;gap:10px;margin-bottom:4px;"><div class="review-avatar">'+popupInitial+'</div><div><div class="reviews-popup__card-stars">'+_stars(r.score)+'</div>'+
          '<div class="reviews-popup__card-meta">'+_esc(r.author)+' · '+_date(r.date)+verifiedHtml+'</div></div></div>'+
          '<div class="reviews-popup__card-title">'+_esc(r.title)+'</div>'+
          '<div class="reviews-popup__card-body">'+_esc(r.content).replace(/\n/g,'<br>')+'</div>'+
          photosHtml;
        body.appendChild(card);
      });
      _popupBuilt = true;
    }

    function _updatePopupCounter() {
      var txt = (_popupIdx + 1) + ' / ' + _sorted.length;
      if (!document.getElementById('reviews-popup-counter')) return;
      document.getElementById('reviews-popup-counter').textContent = txt;
      document.getElementById('reviews-popup-nav-counter').textContent = txt;
      document.getElementById('reviews-popup-prev').disabled = _popupIdx === 0;
      document.getElementById('reviews-popup-next').disabled = _popupIdx === _sorted.length - 1;
    }

    window.openReviewsPopup = function() {
      _buildPopupCards();
      _popupIdx = 0;
      var cards = document.querySelectorAll('.reviews-popup__card');
      cards.forEach(function(c) { c.classList.remove('active'); });
      if (cards[0]) cards[0].classList.add('active');
      _updatePopupCounter();
      document.getElementById('reviews-popup').classList.add('active');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', _popupKey);
    };

    window.closeReviewsPopup = function() {
      document.getElementById('reviews-popup').classList.remove('active');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', _popupKey);
    };

    window.reviewsPopupNav = function(dir) {
      var cards = document.querySelectorAll('.reviews-popup__card');
      var next = _popupIdx + dir;
      if (next < 0 || next >= cards.length) return;
      cards[_popupIdx].classList.remove('active');
      _popupIdx = next;
      cards[_popupIdx].classList.add('active');
      _updatePopupCounter();
    };

    function _popupKey(e) {
      if (e.key === 'Escape') closeReviewsPopup();
      if (e.key === 'ArrowLeft') reviewsPopupNav(-1);
      if (e.key === 'ArrowRight') reviewsPopupNav(1);
    }
  })();

  function openReviewLightbox(url) {
    var lb = document.getElementById('review-lightbox');
    var img = document.getElementById('review-lightbox-img');
    img.src = url;
    lb.classList.add('active');
    document.addEventListener('keydown', _lbKeyClose);
  }
  function closeReviewLightbox() {
    document.getElementById('review-lightbox').classList.remove('active');
    document.removeEventListener('keydown', _lbKeyClose);
  }
  function _lbKeyClose(e) { if (e.key === 'Escape') closeReviewLightbox(); }

  

/* ---------- */


    function goToCheckout() {
      var v = getVariant(activeSize, activeColor);
      if (!v) return;

      /* checkout: permalink de carrinho da propria loja. */
      if (!v.checkout) { alert('Checkout is being set up — available very soon.'); return; }

      var match = v.checkout.match(/\/cart\/(\d+):/);
      var variantId = match ? match[1] : null;

      if (!variantId) { window.location.href = v.checkout; return; }

      var qty = parseInt(document.querySelector('.mpdp .quantity-selector').value) || 1;

      var bounce = new URL(window.location.origin + '/cart/' + variantId + ':' + qty);
      bounce.searchParams.set('skip_shop_pay', 'true');

      /* bundle phantom: o codigo viaja na propria URL e ja chega aplicado no checkout */
      var tier = bundleFor(qty);
      if (tier) bounce.searchParams.set('discount', tier.code);

      var allowed = ['fbclid','ttclid','gclid','msclkid','utm_id','utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
      var pageParams = new URLSearchParams(window.location.search);
      allowed.forEach(function(k) { if (pageParams.has(k)) bounce.searchParams.set(k, pageParams.get(k)); });

      /* Meta: InitiateCheckout ao sair da landing para o checkout.
         O fbq aqui e o que a UTMify ja carregou (pixel 1753038472398140);
         so complementamos o evento que ela nao dispara, com valor e itens. */
      try {
        if (window.fbq) {
          var mval = parseFloat(v.price) * qty;
          if (tier) mval = mval * (1 - tier.off / 100);
          fbq('track', 'InitiateCheckout', {
            content_ids: [v.sku], content_type: 'product', num_items: qty,
            value: Math.round(mval * 100) / 100, currency: D.currency
          });
        }
      } catch (e) {}

      var a = document.createElement('a');
      a.href = bounce.toString();
      a.rel = 'noreferrer noopener';
      a.referrerPolicy = 'no-referrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  

/* ---------- */


  (function(){
    var el = document.getElementById('promo-deadline-date');
    if(!el) return;
    if (!D.promoDeadline) { var box = el.closest('.promo-deadline'); if (box) box.style.display = 'none'; return; }
    el.textContent = new Date(D.promoDeadline + 'T12:00:00Z').toLocaleDateString('en-US',
      { timeZone: 'America/New_York', month: 'long', day: 'numeric', year: 'numeric' });
    return;
    el.textContent = new Date().toLocaleDateString('en-US', {timeZone: 'America/New_York', month:'long', day:'numeric', year:'numeric'});
  })();

  /* Entrega estimada - fonte unica de verdade: usada no bloco de compra E na guia de tallas,
     para as duas nunca divergirem. Janela estipulada: +10 a +20 dias corridos a partir de hoje. */
  function entregaEstimada() {
    var now = new Date();
    var d1 = new Date(now.getTime() + 10*86400000);
    var d2 = new Date(now.getTime() + 20*86400000);
    function fmt(d, o) { o.timeZone = 'America/New_York'; return d.toLocaleDateString('en-US', o); }
    var day1 = fmt(d1, { day: 'numeric' }), day2 = fmt(d2, { day: 'numeric' });
    var mon1 = fmt(d1, { month: 'long' }),  mon2 = fmt(d2, { month: 'long' });
    var yr1  = fmt(d1, { year: 'numeric' }), yr2  = fmt(d2, { year: 'numeric' });
    var ini = mon1 + ' ' + day1;
    if (yr1 !== yr2) ini += ', ' + yr1;
    var fim = (mon1 === mon2 ? day2 : mon2 + ' ' + day2) + ', ' + yr2;
    return ini + ' \u2013 ' + fim;
  }

  (function(){
    var txt = entregaEstimada();
    ['delivery-estimate-date', 'acc-entrega'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = txt;
    });
  })();

  function toggleAccordion(btn) {
    var item = btn.closest('.zwg-accordion__item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.zwg-accordion__item.open').forEach(function(el){ el.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  }

  function openDescModal() {
    var variant = getVariant(activeSize, activeColor);
    if (variant) {
      document.getElementById('modal-masze').textContent   = variant.dims_cm   || '—';
      document.getElementById('modal-gewicht').textContent = variant.weight     || '—';
      document.getElementById('modal-volumen').textContent = variant.volume     || '—';
    }
    document.getElementById('desc-modal-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  /* â”€â”€ Size guide modal â”€â”€ */
  
  var SIZE_GUIDE = D.sizeGuide;
  var sgUnit = 'imperial';

  function renderSizeGuide() {
    var box = document.getElementById('sg-cards');
    if (!box) return;
    box.innerHTML = '';
    SIZE_GUIDE.forEach(function(s) {
      var dims = sgUnit === 'metric' ? s.cm  : s.in;
      var wt   = sgUnit === 'metric' ? s.kg  : s.lbs;
      var vol  = sgUnit === 'metric' ? s.l   : s.gal;
      var card = document.createElement('div');
      card.className = 'sg-card';
      card.innerHTML =
        '<img class="sg-card__img" src="' + s.img + '" alt="' + s.name + '" loading="lazy">' +
        '<div class="sg-card__name">' + s.name + '</div>' +
        '<div class="sg-card__spec">' + dims + '</div>' +
        '<div class="sg-card__spec">' + wt + '</div>' +
        '<div class="sg-card__spec">' + vol + '</div>' +
        '<div class="sg-card__pack"><strong>' + s.outfits + '</strong><span>Estimated delivery: ' + entregaEstimada() + '</span></div>';
      box.appendChild(card);
    });
  }
  function setSizeGuideUnit(u) {
    sgUnit = u;
    document.getElementById('sg-tab-metric').classList.toggle('active', u === 'metric');
    document.getElementById('sg-tab-imperial').classList.toggle('active', u === 'imperial');
    renderSizeGuide();
  }
  function openSizeGuide() {
    renderSizeGuide();
    document.getElementById('sg-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    document.getElementById('sg-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSizeGuide();
  });
  

/* ---------- */


/* ---------- textos que dependem da FICHA da linha ativa ----------
   Antes eram parágrafos fixos com os números de uma linha só, e apareciam iguais na
   outra. Agora saem do mesmo dado que alimenta o dropdown e o guia de tamanhos. */
function _porExtenso(n) {
  return ({1:'One',2:'Two',3:'Three',4:'Four'})[n] || String(n);
}
/* escape proprio: o minificador da Shopify embute o _esc do bloco de reviews
   onde ele e usado, e a referencia daqui quebra em producao. */
function _escF(s) {
  return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function atualizarTextosDaFicha() {
  var v = getVariant(activeSize, activeColor);

  /* FAQ: peso e medida de cada talla */
  var el = document.getElementById('faq-medidas');
  if (el) {
    var partes = (D.sizeGuide || []).filter(function(s){ return s['in'] || s.kg; }).map(function(s){
      var t = 'The <strong>' + _escF(s.name) + '</strong>';
      if (s.lbs) t += ' weighs ' + _escF(s.lbs);
      if (s.l)   t += (s.lbs ? ', holds ' : ' holds ') + _escF(s.l);
      if (s['in']) t += (s.lbs || s.l ? ' and measures ' : ' measures ') + _escF(s['in']);
      return t + '.';
    });
    el.innerHTML = partes.length
      ? 'Weight and dimensions vary by size. ' + partes.join(' ')
      : 'Measurements for this line are being confirmed with the manufacturer.';
  }

  /* FAQ: bagagem de mão — sem afirmar norma de companhia que nao da para verificar */
  var cab = document.getElementById('faq-cabine');
  if (cab) {
    var menor = (D.sizeGuide || [])[0];
    if (menor && (menor['in'] || menor.cm)) {
      var med = menor['in'] ? _escF(menor['in']) : '';
      if (menor.cm) med += (med ? ' / ' : '') + _escF(menor.cm);
      cab.innerHTML = 'The smallest size is the <strong>' + _escF(menor.name) + '</strong>, at ' + med +
        '. Carry-on limits change from airline to airline, so check the maximum your carrier allows before you fly.';
    } else {
      cab.innerHTML = 'Measurements for this line are being confirmed with the manufacturer.';
    }
  }

  /* nº de fechaduras: varia por talla (o fabricante usa 2 nas menores e 3 nas maiores) */
  var n = v && v.locks ? v.locks : null;
  var inc = document.getElementById('inc-locks');
  if (inc) inc.textContent = n ? String(n) : '2';
  var mod = document.getElementById('modal-locks');
  if (mod) mod.textContent = n ? _porExtenso(n) : 'Two';

  sincronizarBundle();
}
/* ---------- eixo de BRANDING ----------
   Primeiro seletor da escada: imagem -> branding -> talla -> cor.
   Trocar de branding troca a matriz inteira (tallas, cores, precos, galeria). */
var activeBranding = D.activeBranding;

function montarBranding() {
  var box = document.getElementById('branding-options');
  if (!box) return;
  box.innerHTML = '';
  /* uma opcao so (linha vendida sozinha): some o seletor E o rotulo */
  var rot = document.querySelector('.mpdp .branding-label');
  if (!D.brandings || D.brandings.length < 2) {
    box.style.display = 'none';
    if (rot) rot.style.display = 'none';
    return;
  }
  if (rot) rot.style.display = '';
  D.brandings.forEach(function(nome){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'branding-chip' + (nome === activeBranding ? ' selected' : '');
    b.dataset.branding = nome;
    b.textContent = nome;
    b.onclick = function(){ selectBranding(nome); };
    box.appendChild(b);
  });
}

function selectBranding(nome) {
  var g = D.byBranding[nome];
  if (!g) return;
  activeBranding = nome;
  VARIANTS = g.variants;
  SIZE_ORDER = g.sizeOrder;
  ALL_COLORS = g.colors;
  COLOR_LABELS = g.colorLabels;
  /* SIZE_GUIDE foi ligado ao array da opcao INICIAL; sem reatribuir aqui, o guia de
     tamanhos continua listando as tallas da outra opcao (o Branding aparecia sem o Trunk). */
  SIZE_GUIDE = g.sizeGuide;
  D.sizeGuide = g.sizeGuide;

  var lbl = document.getElementById('selected-branding-name');
  if (lbl) lbl.textContent = nome;
  document.querySelectorAll('.mpdp .branding-chip').forEach(function(c){
    c.classList.toggle('selected', c.dataset.branding === nome);
  });

  /* talla e cor atuais podem nao existir nesta opcao: cai na primeira disponivel */
  if (!VARIANTS[activeSize]) activeSize = SIZE_ORDER[0];
  var cores = getColorsForSize(activeSize);
  if (!cores.length) {
    activeColor = '';
  } else if (!cores.some(function(c){ return c.name === activeColor; })) {
    activeColor = cores[0].name;
  }
  /* linha de cor some quando a opcao nao tem cor cadastrada */
  var rowCor = document.querySelector('.mpdp .color-label');
  var boxCor = document.getElementById('color-swatches');
  var temCor = cores.length > 0;
  if (rowCor) rowCor.style.display = temCor ? '' : 'none';
  if (boxCor) boxCor.style.display = temCor ? '' : 'none';

  buildSizeBlocks();
  buildColorSwatches();
  selectSize(activeSize);
}


/* ---------- */


/* Barra de unidades: usa o estoque REAL da variante (D.stock), nunca numero aleatorio.
   Sem estoque controlado, o bloco e escondido em vez de exibir um numero inventado. */
(function() {
  var c = document.getElementById('urgency-count'), f = document.getElementById('urgency-fill');
  if (!c || !f) return;
  var units = parseInt(D.stock, 10);
  if (!isFinite(units) || units <= 0) {
    var w = c.closest('.urgency-bar'); if (w) w.style.display = 'none'; return;
  }
  c.textContent = units;
  f.style.width = Math.max(6, Math.min(100, Math.round((units / (D.stockFull || 12)) * 100))) + '%';
})();

document.addEventListener('DOMContentLoaded', function() {
  var io = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { entry.target.classList.add('in'); observer.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
  document.querySelectorAll('.mpdp .sr').forEach(function(el) { io.observe(el); });
});


/* ---------- */


/* A origem abria o drawer proprio dela; aqui usamos /cart/add.js e o drawer do tema.
   Se a quantidade cair numa faixa de desconto, o codigo e aplicado na sessao do carrinho
   para o valor exibido na pagina ser o mesmo cobrado. */
/* --- leitura do bundle do Kaching ---
   NAO montar a linha na mao a partir da quantidade: num pacote o cliente escolhe
   uma variante DIFERENTE por unidade (2 unidades = pode ser 1 preta + 1 prata), e
   cada linha precisa da propriedade __kaching_bundles, que e o que faz o desconto
   do app valer. O componente ja devolve as linhas prontas em items(). */
function kachingQtdEsperada() {
  var radio = document.querySelector('input[name^="kaching-bundles-deal-"]:checked');
  /* a copia do app embed no <head> nao acompanha a troca de produto; a boa e a
     que vem dentro do bloco da PDP */
  var cfg = document.querySelector('.app-blocks script.kaching-bundles-deal-block-settings')
         || document.querySelector('script.kaching-bundles-deal-block-settings');
  if (!radio || !cfg) return null;
  try {
    var barras = (JSON.parse(cfg.textContent) || {}).dealBars || [];
    for (var i = 0; i < barras.length; i++) {
      if (barras[i].id === radio.value) return parseInt(barras[i].quantity, 10) || null;
    }
  } catch (e) {}
  return null;
}

/* ---- o bundle tem que ACOMPANHAR a pagina ----
   Nesta loja cada tamanho e cada cor e um PRODUTO diferente, e a caixa de compra troca
   de produto no cliente, sem recarregar. O bloco do app e renderizado pelo servidor
   para o produto do Liquid, entao congelava no primeiro: trocar para o Trunk e o widget
   seguia na Cabin S — e era a Cabin S que ia para o carrinho. Aqui o bloco e
   re-renderizado pela Section Rendering API a cada troca. */
var _bundleUrl = null;
function sincronizarBundle() {
  var caixa = document.querySelector('.app-blocks');
  var raiz = document.querySelector('.mpdp');
  if (!caixa || !raiz) return;
  var v = getVariant(activeSize, activeColor);
  if (!v || !v.url) return;
  var url = String(v.url).split('?')[0];
  if (url === _bundleUrl) return;
  _bundleUrl = url;
  var sec = raiz.closest('[id^=shopify-section-]');
  if (!sec) return;
  var sid = sec.id.replace('shopify-section-', '');
  caixa.style.opacity = '.45';
  fetch(url + '?section_id=' + encodeURIComponent(sid))
    .then(function (r) { return r.text(); })
    .then(function (t) {
      if (_bundleUrl !== url) return;            /* o cliente trocou de novo no meio */
      var novo = new DOMParser().parseFromString(t, 'text/html').querySelector('.app-blocks');
      if (!novo) return;
      caixa.innerHTML = '';
      /* innerHTML nao executa <script>: recriar cada um, senao o app nao acha a config */
      [].slice.call(novo.childNodes).forEach(function (n) {
        if (n.nodeName === 'SCRIPT') {
          var e = document.createElement('script');
          if (n.type) e.type = n.type;
          if (n.className) e.className = n.className;
          if (n.id) e.id = n.id;
          e.textContent = n.textContent;
          caixa.appendChild(e);
        } else {
          caixa.appendChild(document.importNode(n, true));
        }
      });
      if (typeof window.kachingBundlesInitialize === 'function') window.kachingBundlesInitialize();
    })
    .catch(function () {})
    .then(function () { caixa.style.opacity = ''; });
}

function kachingBloco() {
  var b = document.querySelector('kaching-bundles-block');
  return (b && typeof b.items === 'function') ? b : null;
}

/* O widget carrega depois da pagina; por isso a espera. */
(function () {
  function esconderControlesDuplicados() {
    if (!document.querySelector('.kaching-bundles')) return false;
    var s = document.querySelector('.mpdp .quantity-selector');
    if (s) s.style.display = 'none';
    var h = document.getElementById('bundle-hint');
    if (h) h.style.display = 'none';
    return true;
  }
  if (!esconderControlesDuplicados()) {
    var n = 0;
    var t = setInterval(function () {
      if (esconderControlesDuplicados() || ++n > 24) clearInterval(t);
    }, 500);
  }
})();

function addAlCarrito() {
  var v = getVariant(activeSize, activeColor);
  if (!v || !v.id) return;
  /* Com o bloco do Kaching na pagina e ELE quem define o que vai pro carrinho.
     O seletor de quantidade da pagina fica escondido para nao haver dois controles. */
  var kb = kachingBloco();
  var itensKb = null;
  if (kb) {
    try {
      /* pacote com slot vazio: o proprio widget marca o que falta escolher */
      if (typeof kb.isItemSelectionValid === 'function' && !kb.isItemSelectionValid()) {
        if (typeof kb.validateItemSelection === 'function') kb.validateItemSelection();
        return;
      }
      var lin = kb.items();
      /* Slot ainda nao escolhido: items() volta curto e o isItemSelectionValid()
         NAO acusa — sem tratar, o cliente escolhe pacote de 2 e leva 1 unidade com o
         desconto de 2. Bloquear deixava o botao mudo (o seletor do app nao abre por
         clique programatico), entao aqui a linha principal e completada ate a
         quantidade do pacote: escolha explicita e respeitada, ausencia vira mais
         unidades da mala que o cliente esta vendo. */
      /* Qual linha e a do produto que a pagina esta mostrando. NAO e sempre a
         primeira: quando o cliente escolhe o segundo slot do pacote, o escolhido
         vem na frente e o da pagina fica atras. */
      var iPrincipal = -1;
      for (var k = 0; k < (lin || []).length; k++) {
        if (Number(lin[k].id) === Number(v.id)) { iPrincipal = k; break; }
      }
      var esperado = kachingQtdEsperada();
      var total = (lin || []).reduce(function (t, x) { return t + (parseInt(x.quantity, 10) || 1); }, 0);
      if (esperado && lin && lin.length && total < esperado) {
        var alvo = iPrincipal >= 0 ? iPrincipal : 0;
        lin[alvo].quantity = (parseInt(lin[alvo].quantity, 10) || 1) + (esperado - total);
      }
      /* trava: se o bloco ainda estiver no produto anterior (sincronizacao a caminho),
         nao usar items() — senao vai a mala errada para o carrinho.
         Basta o produto da pagina estar EM QUALQUER posicao da lista; exigir que
         fosse a primeira derrubava o pacote inteiro assim que o cliente escolhia
         o segundo item, e ia 1 unidade sem desconto para o carrinho. */
      if (lin && lin.length && iPrincipal >= 0) itensKb = lin;
    } catch (e) { itensKb = null; }
  }
  var sel = document.querySelector('.mpdp .quantity-selector');
  var qty = itensKb
    ? itensKb.reduce(function (t, x) { return t + (parseInt(x.quantity, 10) || 1); }, 0)
    : (sel ? (parseInt(sel.value, 10) || 1) : 1);
  var qk = itensKb ? qty : null;
  var btn = document.getElementById('add-btn');
  var label = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = (D.strings && D.strings.adding) || '...'; }
  /* Nota: o observador de carrinho do Horizon loga um aviso de section rendering quando
     o add nao vem do form dele. Nao afeta a compra — o item entra e o cliente vai ao carrinho. */
  fetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: itensKb || [{ id: Number(v.id), quantity: qty }] })
  }).then(function(r) { return r.json(); }).then(function() {
    if (btn) { btn.disabled = false; btn.textContent = label; }
    /* Gaveta lateral.
       O carrinho da loja e o UpCart. A gaveta nativa do Horizon nao existe mais
       (settings_data.current.cart_type = 'page'), entao procurar so por
       cart-drawer-component sempre falhava e o cliente caia na pagina /cart.
       Ordem: UpCart -> gaveta nativa (se um dia voltar) -> pagina /cart.
       O evento 'cart:update' continua sendo disparado porque o contador do
       header do Horizon ouve ele para atualizar o numero de itens. */
    function abrirGaveta(cartJson) {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cartJson, sourceId: 'mpdp-buybox', data: {} };
      document.dispatchEvent(ev);
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; }
      var d = document.querySelector('cart-drawer-component');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      return false;
    }
    /* o UpCart pode ainda estar carregando no primeiro clique: esperar ate 3s
       por ele antes de desistir e mandar o cliente para a pagina /cart */
    var seguir = function (cartJson) {
      if (abrirGaveta(cartJson)) return;
      var n = 0;
      var iv = setInterval(function () {
        if (typeof window.upcartOpenCart === 'function') { clearInterval(iv); window.upcartOpenCart(); }
        else if (++n > 20) { clearInterval(iv); window.location.href = '/cart'; }
      }, 150);
    };
    /* quem da o desconto de 2 e 3 unidades e a funcao do Kaching Bundles, que
       aplica sozinha no carrinho e no checkout. Aplicar tambem o codigo MALA
       empilhava um segundo desconto por cima do mesmo item. */
    fetch('/cart.js').then(function (r) { return r.json(); }).then(seguir).catch(function () { seguir(null); });
  }).catch(function() {
    if (btn) { btn.disabled = false; btn.textContent = label; }
    window.location.href = '/cart';
  });
}


/* ---------- */


/* o markup portado usa onclick inline, entao as funcoes precisam ser globais */
['galleryPrev','galleryNext','selectThumb','selectSize','selectColor','toggleSizeDropdown',
 'openSizeGuide','closeSizeGuide','setSizeGuideUnit','openDescModal','toggleAccordion','goToShop',
 'goToCheckout','addAlCarrito','updateBundleHint','openReviewLightbox','closeReviewLightbox',
 'selectBranding','montarBranding','atualizarTextosDaFicha']
.forEach(function(n){ try { if (typeof eval(n) === 'function') window[n] = eval(n); } catch(e){} });
})();


/* ---------- carrossel de videos (UGC) ----------
   IIFE propria: nao depende do motor da PDP, entao um nao derruba o outro. */
(function () {
  var rail = document.getElementById('vidrail');
  if (!rail) return;
  var cards = [].slice.call(rail.querySelectorAll('.vidcard'));
  if (!cards.length) return;
  var box = document.getElementById('vidbox');
  var boxV = document.getElementById('vidbox-v');

  /* so toca o que esta na tela: seis videos juntos travam o celular, e o
     preload='none' do markup so vira 'auto' quando o card aparece. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (!v) return;
        if (e.isIntersecting) {
          if (v.preload !== 'auto') v.preload = 'auto';
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});   /* autoplay bloqueado: fica no poster */
        } else { v.pause(); }
      });
    }, { threshold: 0.5 });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* ---- abrir em tela cheia, com som ---- */
  function pausarTrilho() { cards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); }); }
  function retomarTrilho() {
    cards.forEach(function (c) {
      var v = c.querySelector('video');
      if (!v) return;
      var r = c.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
  }
  function abrir(src, tempo) {
    if (!box || !boxV) return;
    pausarTrilho();
    boxV.src = src;
    boxV.currentTime = tempo || 0;
    boxV.muted = false;
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    var pr = boxV.play();
    if (pr && pr.catch) pr.catch(function () { boxV.muted = true; boxV.play(); });  /* sem gesto: abre mudo */
  }
  function fechar() {
    if (!box || !boxV) return;
    boxV.pause();
    boxV.removeAttribute('src');
    boxV.load();
    box.hidden = true;
    document.body.style.overflow = '';
    retomarTrilho();
  }
  if (box) {
    var x = document.getElementById('vidbox-x');
    if (x) x.addEventListener('click', fechar);
    box.addEventListener('click', function (e) { if (e.target === box) fechar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) fechar(); });
  }

  /* arrastar: no celular o overflow-x arrasta sozinho; no desktop, nao.
     Sem isto o carrossel parece travado no mouse — e nao da erro nenhum. */
  var down = false, x0 = 0, s0 = 0, moveu = 0;
  rail.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    down = true; moveu = 0; x0 = e.clientX; s0 = rail.scrollLeft;
    rail.classList.add('dragging');
  });
  rail.addEventListener('pointermove', function (e) {
    if (!down) return;
    var d = e.clientX - x0;
    moveu = Math.max(moveu, Math.abs(d));
    rail.scrollLeft = s0 - d;
    e.preventDefault();
  });
  ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
    rail.addEventListener(ev, function () { down = false; rail.classList.remove('dragging'); });
  });

  /* o clique so abre se NAO foi arraste — senao arrastar o trilho abria um video */
  cards.forEach(function (c) {
    c.addEventListener('click', function (e) {
      if (moveu > 6) { e.preventDefault(); return; }
      var v = c.querySelector('video');
      abrir(c.getAttribute('data-src'), v ? v.currentTime : 0);
    });
  });
})();
